import { useReducer} from "react";
import api from "../../../../../api/quiz";

const intialState = {
  statisticItems: []
};

function reducer(state, action) {
  switch (action.type) {
    case "STATISTIC_ITEM_LIST":
      return {
        ...state,
        statisticItems: action.statisticItems
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useStatistic() {
  const [statisticData, dispatch] = useReducer(reducer, intialState);

  function getQuestionStatisticItems(id) {
    api.getQuestionStatistic(id).then(response => {
      if (response.status === 200) {
        dispatch({ type: "STATISTIC_ITEM_LIST", statisticItems: response.data});
      } else {
        dispatch({ type: "STATISTIC_ITEM_LIST", statisticItems: []});
      }
      return Promise.resolve();
    }).catch(err => {
      dispatch({ type: "STATISTIC_ITEM_LIST", statisticItems: []});
    });
  }

  return {
    statisticData,
    getQuestionStatisticItems
  };
}
